import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CanvasGridComponent } from './canvas-grid/canvas-grid.component'

const DECLARATIONS = [
    CanvasGridComponent,
]

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
        ...DECLARATIONS,
    ],
    declarations: [
        ...DECLARATIONS,
    ],
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts